import React, { useState, useEffect } from 'react';
import { getUserById, encryptPassword, editUser, createUser } from '../service/authService';
import Input from '../common/Input';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const initUser = {
   username: '',
   password: '',
   confirm: '',
   email: '',
   roles: [],
   accounts: [],
};

export default function ChangePassword(props) {
   const { userId } = props.match.params;
   const formik = useFormik({
      initialValues: { ...initUser },
      validationSchema: validation,
      onSubmit: (values, setSubmitting) => {
         console.log(edit);
         if (edit) {
            handleChangePassword(values);
         }
         setSubmitting(false);
      },
   });
   const [edit, setEdit] = useState(false);

   const fetchUserById = () => {
      if (userId) {
         getUserById(userId)
            .then((response) => {
               let foundUser = response.data.data;
               formik.setValues(foundUser);
               console.dir(foundUser);
               setEdit(true);
            })
            .catch((error) => {
               toast.error('An error occurs !!!');
               console.dir(error);
            });
      } else {
         setEdit(false);
      }
   };
   useEffect(fetchUserById, []);

   const handleChangePassword = (values) => {
      let requestData = { ...values };
      if (!values.accounts) {
         requestData.accounts = [];
      }
      requestData.password = encryptPassword(values.password);
      requestData.confirm = encryptPassword(values.confirm);
      console.dir(requestData);
      editUser(requestData)
         .then((response) => {
            const editedUser = response.data.data;
            let editedUsername = editedUser.username;
            toast.info(`Password for user ${editedUsername} has been edited successfully`, { autoClose: 2000 });
            props.history.push('/UserList');
         })
         .catch((error) => {
            toast.error("An error occurs !! Can't edit user", { autoClose: 2000 });
            console.dir(error);
         });
   };

   const onCancel = (e) => {
      e.preventDefault();
      props.history.push('/UserList');
   };

   return (
      <div className='container'>
         <div className='row'>
            <div className='col-md-6 offset-md-3'>
               <form className='form' onSubmit={formik.handleSubmit}>
                  <h5 className='text-muted'>Change Password</h5>
                  <hr />
                  {edit && (
                     <div className='form-row'>
                        <div className='form-group col-md-6'>
                           <label>Password</label>
                           <Input
                              type='password'
                              className='form-control form-control-sm custom-input'
                              name='password'
                              id='password'
                              value={formik.values.password}
                              onChange={formik.handleChange}
                           />
                           {formik.errors.password && formik.touched.password && <div className='invalid-feedback'>{formik.errors.password}</div>}
                        </div>
                        <div className='form-group col-md-6'>
                           <label htmlFor='confirm'>Confirm Password</label>
                           <Input
                              type='password'
                              className='form-control form-control-sm custom-input'
                              name='confirm'
                              id='confirm'
                              value={formik.values.confirm}
                              onChange={formik.handleChange}
                           />
                           {formik.errors.confirm && formik.touched.confirm && <div className='invalid-feedback'>{formik.errors.confirm}</div>}
                        </div>
                     </div>
                  )}
                  <div className='form-group'>
                     <button type='submit' className='btn btn-sm btn-primary btn-custom-blue mr-2' disabled={formik.isSubmitting}>
                        {edit ? 'Change User' : 'Create User'}
                     </button>
                     <button className='btn btn-sm btn-outline-info' onClick={onCancel}>
                        Cancel
                     </button>
                  </div>
               </form>
            </div>
         </div>
      </div>
   );
}

const validation = Yup.object({
   username: Yup.string().min(5, 'Username is too short').max(64, 'Username is too long.max 64 characters').required('Username is required'),
   email: Yup.string().email('Invalid email ').required('Email is required '),
   password: Yup.string().min(5, 'Password is too short').max(64, 'Password is too long.max 64 characters').required('Password is required'),
   confirm: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Password must match')
      .required('Confirm password is required'),
   roles: Yup.array().min(1, 'User role should be at least one'),
   accounts: Yup.array().nullable(),
});
